import React from "react";

const Previewsteps = ({ setCurrentopenpage }) => {
  return (
    <>
      <div className="col-12">
        <p
          style={{
            color: "red",
            textAlign: "center",
            fontWeight: '700'
          }}
        >
          Due to copyright restrictions, only one chapter of this book can be
          previewed.
        </p>
      </div>
    </>
  );
};

export default Previewsteps;
